<template src="./index.html"></template>
<style src="./index.scss" lang="scss" scoped></style>
<script>
import { Search } from "vant";
import { mapState } from "vuex";
export default {
  components: { Search },
  computed: {
    ...mapState({
      SearchData: (state) => {
        return state.CustomerMessage.SearchData;
      },
      getMessagelist: (state) => {
        return state.CustomerMessage.getMessagelist;
      },
      getSappMenuInfo: (state) => {
        return state.Public.getSappMenuInfo;
      },
    }),
  },
  name: "CustomerMessageSearchPage",
  data() {
    return {
      data: [],
      searchValue: "",
    };
  },
  mounted() {

    if (this.$route.params.active == "focus") {
      setTimeout(() => {
        document.getElementById("searchInput").focus();
      }, 500);
      this.$store.commit("CustomerMessage/clear_SearchData", {});
    }

    if (this.$store.state.Public.CustomerSearchData) {
      this.searchValue = this.$store.state.Public.CustomerSearchData.value;
      if (this.$store.state.Public.CustomerSearchData.data) {
        this.$store.commit("CustomerMessage/SET_DATA", {
          key: "SearchData",
          data: this.$store.state.Public.CustomerSearchData.data,
        });
        this.$store.commit("Public/SET_DATA", {
          key: "CustomerSearchData",
          data: {},
        });
      } else {
        this.$store.commit("CustomerMessage/SET_DATA", {
          key: "SearchData",
          data: [],
        });
      }
    }
  },
  methods: {
    // 监听页面滑动，页面滑动输入框失去焦点收起键盘
    touchstart() {
      document.getElementById("searchInput").blur()
    },
    onSearch() {
      let value = this.searchValue;
      setTimeout(() => {
        if (value == this.searchValue) {
          if (this.searchValue) {
            let params = { ww_nick: this.searchValue };
            this.getTableData(params).then((res) => {
              if (this.searchValue == "") { // 有可能在请求时删除了搜索内容,导致请求后的数据被赋值
                this.$store.commit("CustomerMessage/clear_SearchData", {});
              }
            });
          } else {
            this.$store.commit("CustomerMessage/clear_SearchData", {});
          }
        }
      }, 1000);
    },
    noneSearch() {
      this.$router.go(-1);
    },
    async getTableData(params) {
      let res = await this.$store.dispatch("CustomerMessage/SearchData", params)
      this.data = res.data;
      return res
    },

    jump_ChatRoom(item, index) {
      // 取消小红点
      if (
        this.getSappMenuInfo.customer_message_num > 0 &&
        item.is_exist_xunread != 0
      ) {
        this.getSappMenuInfo.customer_message_num =
          parseFloat(this.getSappMenuInfo.customer_message_num) -
          parseFloat(item.is_exist_xunread);
        item.is_exist_xunread = 0;
      }
      if (this.getMessagelist) {
        for (let i in this.getMessagelist.list) {
          if (this.getMessagelist.list[i].ww_nick == item.ww_nick) {
            this.getMessagelist.list[i] = item;
          }
        }
      }
      // 跳转聊天详情
      this.$router.push({
        path: "ChatRoom",
        query: { ww_nick: item.ww_nick, 
                title: item.ww_nick,  
                is_in_list: item.is_in_list,
                source: '1'
        },
      });
      let dataObj = { value: this.searchValue, data: this.SearchData };
      this.$store.commit("Public/SET_DATA", {
        key: "CustomerSearchData",
        data: dataObj,
      });
    },
  },
};
</script>